import { render } from "./ValuesScale.vue?vue&type=template&id=173de10e"
import script from "./ValuesScale.vue?vue&type=script&lang=js"
export * from "./ValuesScale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__